import { Box, Typography } from '@mui/material';
import React from 'react';

const ErrorMessage = ({ message }) => {
  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      margin: 3
    }}>
      <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '24px', paddingBottom: 2, color: 'red' }}>
        {message}
      </Typography>
    </Box>
  )
}

export default ErrorMessage